import { OrderDistribution } from 'views/order-feed/features/order-distribution/types/order-distribution.type';
import generateMockedDate from 'utils/generate-mocked-date';
import { OrderDistributionStatus } from '../types/order-distribution-status.enum';

const OrderDistributionData: OrderDistribution[] = [
  {
    id: '1bd62280-1f6e-4358-8063-868513dc2029',
    siteId: 'bfd08b43-686d-490c-ab19-fc9c0ffb77f8',
    siteName: 'BORVIKA',
    shipmentId: '20240218-efgh',
    status: OrderDistributionStatus.FINISHED,
    eta: generateMockedDate(1, 'subtract'),
    requestedDeliveryDate: generateMockedDate(2, 'subtract'),
    comment: 'comment from User',
    siteComment: 'Text: \nhttp://vpn.bogus.com.address/ \nText something. else. here, BIGLETTER odd å Ø æ 323248510',
    pointOfContact: '',
    vesselName: 'Eidsvaag Opal',
    distributions: [
      {
        siloId: 'c8d38185-4fdf-4c5e-87fb-302f78d00981',
        siloName: '1',
        siloFleetName: null,
        orderNumber: '1000057614',
        itemNumber: '000000000107553230',
        itemName: 'EWOS EXTRA A A HP 1000 50A BLK',
        quantity: 300,
        isExtraStorage: false,
        isEnabled: true,
      },
      {
        siloId: '91e77634-b913-468d-9194-e297988483a2',
        siloName: 'WAREHOUSE',
        siloFleetName: null,
        orderNumber: '1000057614',
        itemNumber: '000000000107553256',
        itemName: 'EWOS RAPID HP 1000 DERMIC 50A 500',
        quantity: 300,
        isExtraStorage: true,
        isEnabled: true,
      },
      {
        siloId: '39f8ff3e-bb4f-4c61-9119-264ddc6f05b7',
        siloName: '2',
        siloFleetName: null,
        orderNumber: '1000057614',
        itemNumber: '000000000107553256',
        itemName: 'EWOS RAPID HP 1000 DERMIC 50A 500',
        quantity: 1,
        isExtraStorage: false,
        isEnabled: true,
      },
      {
        siloId: '39f8ff3e-bb4f-4c61-9119-264ddc6f05b7',
        siloName: '2',
        siloFleetName: null,
        orderNumber: '1000057614',
        itemNumber: '000000000107553230',
        itemName: 'EWOS EXTRA A A HP 1000 50A BLK',
        quantity: 4,
        isExtraStorage: false,
        isEnabled: true,
      },
    ],
    products: [
      {
        orderNumber: '1000057614',
        itemNumber: '000000000107553230',
        itemName: 'EWOS EXTRA A A HP 1000 50A BLK',
        quantity: 450,
      },
      {
        orderNumber: '1000057614',
        itemNumber: '000000000107553256',
        itemName: 'EWOS RAPID HP 1000 DERMIC 50A 500',
        quantity: 350,
      },
    ],
  },
  {
    id: '3a9eff70-85af-458a-9e3a-6c8354126688',
    siteId: 'bfd08b43-686d-490c-ab19-fc9c0ffb77f8',
    siteName: 'BORVIKA',
    shipmentId: '20240218-ijkl',
    status: OrderDistributionStatus.NOT_STARTED,
    eta: generateMockedDate(2),
    requestedDeliveryDate: generateMockedDate(1),
    comment: 'This is a comment that is special for the delivery',
    siteComment: 'Text: \nhttp://vpn.bogus.com.address/ \nText something. else. here, BIGLETTER odd å Ø æ 323248510',
    pointOfContact: null,
    vesselName: 'Eidsvaag Opal',
    distributions: [],
    products: [
      {
        orderNumber: '1000057760',
        itemNumber: '000000000107553230',
        itemName: 'EWOS EXTRA A A HP 1000 50A BLK',
        quantity: 450,
      },
      {
        orderNumber: '1000057760',
        itemNumber: '000000000107553256',
        itemName: 'EWOS RAPID HP 1000 DERMIC 50A 500',
        quantity: 450,
      },
    ],
  },
  {
    id: '557903e6-d835-445e-bde7-5e774fec0bd9',
    siteId: 'bfd08b43-686d-490c-ab19-fc9c0ffb77f8',
    siteName: 'BORVIKA',
    shipmentId: '20240218-abcd',
    status: OrderDistributionStatus.SILO_CHANGED,
    eta: generateMockedDate(7),
    requestedDeliveryDate: generateMockedDate(5),
    comment: "please don't wreck the barge with your ship you twats ",
    siteComment: 'Text: \nhttp://vpn.bogus.com.address/ \nText something. else. here, BIGLETTER odd å Ø æ 323248510',
    pointOfContact: '',
    vesselName: 'Eidsvaag Opal',
    distributions: [
      {
        siloId: null,
        siloName: 'SILO01',
        siloFleetName: null,
        orderNumber: '1000057613',
        itemNumber: '000000000107553256',
        itemName: 'EWOS RAPID HP 1000 DERMIC 50A 500',
        quantity: 100,
        isExtraStorage: false,
        isEnabled: true,
      },
      {
        siloId: '39f8ff3e-bb4f-4c61-9119-264ddc6f05b7',
        siloName: '2',
        siloFleetName: null,
        orderNumber: '1000057613',
        itemNumber: '000000000107553230',
        itemName: 'EWOS EXTRA A A HP 1000 50A BLK',
        quantity: 50,
        isExtraStorage: false,
        isEnabled: true,
      },
      {
        siloId: '2ac019ff-9dfc-4852-a151-44f7ba42b85b',
        siloName: '3',
        siloFleetName: null,
        orderNumber: '1000057613',
        itemNumber: '000000000107553230',
        itemName: 'EWOS EXTRA A A HP 1000 50A BLK',
        quantity: 100,
        isExtraStorage: false,
        isEnabled: true,
      },
      {
        siloId: null,
        siloName: 'SILO04',
        siloFleetName: null,
        orderNumber: '1000057613',
        itemNumber: '000000000107553256',
        itemName: 'EWOS RAPID HP 1000 DERMIC 50A 500',
        quantity: 200,
        isExtraStorage: false,
        isEnabled: true,
      },
      {
        siloId: null,
        siloName: 'SILO04',
        siloFleetName: null,
        orderNumber: '1000057613',
        itemNumber: '000000000107553230',
        itemName: 'EWOS EXTRA A A HP 1000 50A BLK',
        quantity: 20,
        isExtraStorage: false,
        isEnabled: true,
      },
    ],
    products: [
      {
        orderNumber: '1000057613',
        itemNumber: '000000000107553256',
        itemName: 'EWOS RAPID HP 1000 DERMIC 50A 500',
        quantity: 350,
      },
      {
        orderNumber: '1000057613',
        itemNumber: '000000000107553230',
        itemName: 'EWOS EXTRA A A HP 1000 50A BLK',
        quantity: 450,
      },
    ],
  },
];
export default OrderDistributionData;
